export const errorMessages = {
    required:'Este campo es obligatorio',
    invalidEmail:'Ingresa un email valido',
    invalidCuit:'Solo admite numeros y guiones (-)'
};

export const CBU='1500000800000132172114';

export const validateRequiredFields = (requiredFieldNames,formObject,errorsObject) => {
    requiredFieldNames.forEach(fieldName=>{
        if (!formObject[fieldName]){
            errorsObject[fieldName]='Este campo es obligatorio'
        }
    })
}

// export function validateEmail(email) {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
// }

// export function validateCuit(cuit) {
//     const cuitRegex = /^\d{2}-\d{8}-\d{1}$/;
//     return cuitRegex.test(cuit);
// }